<template>
  <div :class="['tab-container__item achievements_tab', { active: isActive }]">
    <div class="achievements_container">
      <achievement-category v-for="(category, index) in categories"
                            :category="category.achievementName"
                            :category-value="categoryValue(category)"
                            :achievements="category.achievementLevelDTOs"
                            :key="index"/>
    </div>
  </div>
</template>

<script>

import AchievementCategory from '@/components/home/modals/achievements/AchievementCategory';

export default {
  name: 'achievements-tab',
  props: {
    isActive: { type: Boolean, default: false },
    categories: Array,
  },
  components: {
    AchievementCategory,
  },
  data() {
    return {
      newGame: [],
      inProgress: [],
      locked: [],
    };
  },
  methods: {
    /* eslint no-console: "off" */
    categoryValue(category) {
      let indexNew = 0;
      const indexIn = 0;
      const indexLoc = 0;
      for (let i = 0; i < category.achievementLevelDTOs.length; i += 1) {
        if (category.achievementLevelDTOs[i].completed) {
          this.newGame[indexNew] = category.achievementLevelDTOs[i];
          indexNew += 1;
        } else if (category.achievementLevelDTOs[i].current && category.achievementLevelDTOs[i].percentage > 0) {
          this.inProgress[indexIn] = category.achievementLevelDTOs[i];
        } else if (category.achievementLevelDTOs[i].completed) {
          this.locked[indexLoc] = category.achievementLevelDTOs[i];
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/AchievementsTab.vue